<template>
    <div>
      <common-dialog
        ref="dialog"
        width="600px"
        title="订金"
        id-key="ClassId"
        :data="data"
        :line-form="true"
        form-label-width="85px"
        :form-rules="rules"
        :save-func="() => {}" 
        @opened="onOpened"
        @edit-opened="onEditOpened"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-table
            border
            :data="data.tableList"  
            class="tableList"
            :row-class-name="tableRowClassName"
            @row-click="addColumn"
            :summary-method="getSummaries"
            show-summary
          >
            <el-table-column label="序号" min-width="55px" align="center">
              <template slot-scope="{ $index }">
                <span>{{ $index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="结算方式" align="center">
              <template slot-scope="{ row }">
                <!--  -->
                <el-select v-model="row.SettleId">
                  <el-option
                    v-for="item in settleList"
                    :key="item.SettleId"
                    :label="item.SettleName"
                    :value="item.SettleId"
                    @click.native="changeSettle(item, row)"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="账号名称" align="center">
              <!--  -->
              <template slot-scope="{ row }">
                <el-select v-model="row.AccountId">
                  <el-option
                    v-for="item in accountList"
                    :key="item.AccountId"
                    :label="item.AccountName"
                    :value="item.AccountId"
                    @click.native="changeAccount(item, row)"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="订单金额" align="center">
              <template slot-scope="{ row }">
                <el-input type="number" v-model.number="row.ReceiptAmount" @change=" changeT(row)" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click.stop="delTableList(row, $index)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template #footer>
          <el-button type="primary" @click="toSave">保 存</el-button>
          <el-button @click="close">关 闭</el-button>
        </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    },
    data() {
      return {
        data: {
          tableList: [],       
        },
        sum: 0,
        MinusEntry: null,
        settleApi: require("@/api/ba/settle").default,
        accountApi: require("@/api/ba/account").default,
        // trendData: iForm.Data,
        showList: [],
        deleteDateList:[],
        accountList: [],
        settleList: [],
        rules: {
          ClassNo: [{ required: true, message: "请输入分类编码" }],
          ClassName: [{ required: true, message: "请输入分类名称" }],
          Sn: [{ required: true, message: "请输入序号" }],
        },
      };
    },
    methods: {
      addList() {
        this.data.tableList.push({
          T:0,
          OrderPayId: 0,
          // OrderId: 0,
          SettleId: null,
          AccountId: null,
          ReceiptAmount: null,
          // AddTime: "2022-10-19T09:47:12.008Z",
          SettleNo: "",
          SettleName: "",
          AccountNo: "",
          AccountName: "",
          BankNo: "",
          BankName: "",
        });
      },
      changeT( row) {
        if(row.T == null) row.T = 1
      },
      setMinusEntry(MinusEntry){
        console.log('this.data.tableList', this.data.tableList)
        this.MinusEntry = MinusEntry
      },
      changeSettle(item, row) {
        if(row.T == null) row.T = 1
        // console.log('item1',item);
        row.SettleNo = item.SettleNo;
        row.SettleName = item.SettleName;
      },
      changeAccount(item, row) {
         if(row.T == null) row.T = 1
        // console.log('item2',item);
        row.AccountNo = item.AccountNo;
        row.AccountName = item.AccountName;
        row.BankNo = item.BankNo;
        row.BankName = item.BankName;
      },
      tableRowClassName({ row, rowIndex }) {
        row.index = rowIndex;
      },
      // 打开时获取显示显示列表
      onOpened() {
        let tableList = this.$parent.tableList;

        let sum = 0;
        let length = tableList.length;
        for(let i = 0; i < length; ++i){
          sum = sum + parseFloat(tableList[i]?.Amount ?? 0)
        }

        this.sum = sum;
       
         this.data.tableList = this.$parent.data.Receipts.filter(i=>i.T!=2)
        if (this.data.tableList.length == 0) this.addList();
        this.settleApi.list({ Status: 1 }).then((res) => {
          if (res.Code === 0) {
            this.settleList = res.Data;
          }
        });
  
        this.accountApi.list({ Status: 1 }).then((res) => {
          if (res.Code === 0) {
            this.accountList = res.Data;
          }
        });
      },
      addColumn(row, column) {
        if (row.index === this.data.tableList.length - 1) {
          this.addList();
        }
      },
  
      delTableList(data, index) {
        // this.$message.success("删除");
         this.data.tableList.splice(index, 1);
        if(data.T !== 0){
          this.deleteDateList.push(data)
        }
        if (this.data.tableList.length === 0) this.addList();
      },
      onEditOpened(data) {},
      toSave() {
        if(this.deleteDateList.length>0){
          this.deleteDateList.forEach(item=>{ item.T=2 })
       }

   
        const data = this.data.tableList.filter(
          (i) => i.AccountId != null && i.AccountId !== "" && i.SettleId != null && i.SettleId !== ""
        );

        if(data.length === 0){
          return this.$message.warning("记录不能为空");
        }

        if (data.filter((i) => i.ReceiptAmount == null || i.ReceiptAmount == "").length != 0) {
          return this.$message.warning("订单金额不能为空");
        }

        let sum = 0;
        let length = data.length;
        for(let i = 0; i < length; ++i){
          sum = sum + parseFloat(data[i]?.ReceiptAmount ?? 0)
        }

        if(this.MinusEntry === 0){
          if(sum < 0 ||sum > this.sum ){
            return this.$message.warning(`现结金额的数值应大于0且小于等于金额汇总(${this.sum})`);
          }
        }else{
          if( Math.abs(sum) >Math.abs(this.sum)||sum>0){
            return this.$message.warning(`现结金额的数值应小于0且大于等于金额汇总(${this.sum})`);
          }
        }


        this.$emit("data", data,this.deleteDateList);
        this.close(true);
      },
      getSummaries(param) {
        console.log("object", param);
        const { columns, data } = param;
  
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "总价";
            return;
          }
          
          const values = data.map((item) => Number(item["ReceiptAmount"]));
          if (index === 3) {
          // if (!values.every((value) => isNaN(value))) {
            console.log(values);
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] =  sums[index].toFixed(2)  + " 元";
          } else {
            sums[index] = "";
          }
        });
  
        return sums;
      },
      onClosed() {
        this.showList = [];
      },
    },
  };
  </script>
  